import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'api',
})
export class ApiPipe implements PipeTransform {

    transform(type: string, ...args: unknown[]): string {

        switch (type) {
            case 'mail':
                return 'E-Mail';
            default:
                return type;
        }
    }

}
